import {ControlledSelect} from '@hm/fundamental'

import {formatDate} from '../../helpers'
import {useRiskSurveyTranslation} from '../../hooks'
import type {ReportSummaryDto} from '../../types'

type ReportSelectorProps = {
  reports: ReportSummaryDto[]
  selectedReportId: string
  onReportChange: (reportId: string) => void
}

export const ReportSelector = ({
  reports,
  selectedReportId,
  onReportChange
}: ReportSelectorProps) => {
  const {t, i18n} = useRiskSurveyTranslation()
  const paperclipSymbol = '\u{1F4CE}'

  const options = reports.map((r) => ({
    value: r.id,
    label: `${r.siteName} — ${formatDate(r.uploadedAt, i18n.language)}${
      (r.linkCount ?? 0) > 0 ? ` ${paperclipSymbol} ${r.linkCount}` : ''
    }`
  }))

  return (
    <div className="min-w-[300px]">
      <ControlledSelect
        name="reportSelector"
        label={t('plant.selectReport')}
        value={selectedReportId}
        onChange={(value) => onReportChange(String(value))}
        values={options}
        data-cy="report-selector"
      />
    </div>
  )
}
